import React, { useState } from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import WorkIcon from './WorkIcon';
import "react-toggle/style.css";
import Skills from './Skills';
import Tools from './Tools';
import { Link } from 'react-router-dom';

const Work = () => {

    const [isSkillSet, setIsSkillSet] = useState(true);
    const [checked, setChecked] = useState(false);

    const handleChange = () => {
        setChecked(!checked);
        setIsSkillSet(!isSkillSet);
    }

    return (
        <div>
            <div className="relative px-2 py-1 m-4 mx-auto md:mx-0 font-bold pt-[4%] text-2xl sm:text-3xl">
                <img className="w-full h-screen absolute object-cover opacity-20" src="assets/work-bg.jpg" alt="work-bg" />
                <div className="relative flex items-center justify-center">
                    <h1 className="text-white text-4xl items-center justify-center sm:text-4xl md:text-5xl lg:text-6xl pt-14 pb-6 sm:py-8 pl-2 font-bold text-center">
                        Work Experience
                    </h1>
                </div>
            </div>
            <div className="px-2">
                <VerticalTimeline>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: 'transparent', boxShadow: 'none', padding: 0 }}
                        contentArrowStyle={{ borderRight: '7px solid rgb(255, 255, 255)' }}
                        date="Jan, 2024 - Present"
                        iconStyle={{ background: 'rgb(0, 0, 0)', color: '#fff' }}
                        icon={<WorkIcon />}
                    >
                        <div className="skill-card w-full h-full flex flex-col transition-all duration-500 rounded-lg group relative hover:scale-[1.05] cursor-pointer">
                            <div className="h-full w-full rounded-lg border-2 border-[#1f223c] bg-[#11152c] border-b-4 border-b-[rgba(255,255,255,0.7)] shadow-none shadow-gray-50 group-hover:border-violet-500 transition-all duration-500">
                                <div className="flex -translate-y-[1px] justify-center">
                                    <div className="w-3/4">
                                        <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-violet-500 to-transparent" />
                                    </div>
                                </div>
                                <div className="p-6">
                                    <h3 className="vertical-timeline-element-title text-xl sm:text-2xl md:text-3xl font-bold text-white">
                                        Senior Associate
                                    </h3>
                                    <h4 className="vertical-timeline-element-subtitle text-base sm:text-lg font-semibold text-[#AAA6C3]">
                                        PwC India
                                    </h4>
                                    <h4 className="vertical-timeline-element-subtitle text-base sm:text-lg font-semibold text-[#AAA6C3]">
                                        Kolkata, West Bengal, India
                                    </h4>
                                    <ul className="mt-5 list-disc ml-5 space-y-2 text-sm sm:text-base text-left">
                                        <li>Working as a Full Stack Developer on a Client Project.</li>
                                        <li>
                                            Completed <Link to="https://learn.microsoft.com/en-in/users/krishnenduaddya-0360/credentials/b9d79835bb6daff9" target='_blank' className="text-purple-500 font-semibold">Microsoft Certified: DevOps Engineer Expert (AZ-400)</Link> Certification in January, 2026.
                                        </li>
                                        <li>
                                            Completed <Link to="https://learn.microsoft.com/en-us/users/krishnenduaddya-0360/credentials/c1c8ba1482fd3a83" target='_blank' className="text-purple-500 font-semibold">Microsoft Certified: Azure Developer Associate (AZ-204)</Link> Certification in January, 2025.
                                        </li>
                                        <li>Worked on microservice based multiple applications from scratch, developed multiple APIs and integrated with frontend.</li>
                                        <li>Worked on CI/CD pipeline implementation using Azure DevOps.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: 'transparent', boxShadow: 'none', padding: 0 }}
                        contentArrowStyle={{ borderRight: '7px solid rgb(255, 255, 255)' }}
                        date="Nov, 2021 - Jan, 2024"
                        iconStyle={{ background: 'rgb(0,0,0)', color: '#fff' }}
                        icon={<WorkIcon />}
                    >
                        <div className="skill-card w-full h-full flex flex-col transition-all duration-500 rounded-lg group relative hover:scale-[1.05] cursor-pointer">
                            <div className="h-full w-full rounded-lg border-2 border-[#1f223c] bg-[#11152c] border-b-4 border-b-[rgba(255,255,255,0.7)] shadow-none shadow-gray-50 group-hover:border-violet-500 transition-all duration-500">
                                <div className="flex -translate-y-[1px] justify-center">
                                    <div className="w-3/4">
                                        <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-violet-500 to-transparent" />
                                    </div>
                                </div>
                                <div className="p-6">
                                    <h3 className="vertical-timeline-element-title text-xl sm:text-2xl md:text-3xl font-bold text-white">
                                        Associate
                                    </h3>
                                    <h4 className="vertical-timeline-element-subtitle text-base sm:text-lg font-semibold text-[#AAA6C3]">
                                        Cognizant
                                    </h4>
                                    <h4 className="vertical-timeline-element-subtitle text-base sm:text-lg font-semibold text-[#AAA6C3]">
                                        Kolkata, West Bengal, India
                                    </h4>
                                    <ul className="mt-5 list-disc ml-5 space-y-2 text-sm sm:text-base text-left">
                                        <li>Worked as a Full Stack Developer in a Web Application (Client Project).</li>
                                        <li>Developed Email Notifier Application using AWS Lambda.</li>
                                        <li>
                                            Completed <Link to="https://learn.microsoft.com/en-us/users/krishnenduaddya-0360/credentials/e0e495998c206aa9" target='_blank' className="text-purple-500 font-semibold">Microsoft Certified: Azure Fundamentals (AZ-900)</Link> Certification in January, 2023.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: 'transparent', boxShadow: 'none', padding: 0 }}
                        contentArrowStyle={{ borderRight: '7px solid rgb(255, 255, 255)' }}
                        date="July, 2021 - Nov, 2021"
                        iconStyle={{ background: 'rgb(0, 0, 0)', color: '#fff' }}
                        icon={<WorkIcon />}
                    >
                        <div className="skill-card w-full h-full flex flex-col transition-all duration-500 rounded-lg group relative hover:scale-[1.05] cursor-pointer">
                            <div className="h-full w-full rounded-lg border-2 border-[#1f223c] bg-[#11152c] border-b-4 border-b-[rgba(255,255,255,0.7)] shadow-none shadow-gray-50 group-hover:border-violet-500 transition-all duration-500">
                                <div className="flex -translate-y-[1px] justify-center">
                                    <div className="w-3/4">
                                        <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-violet-500 to-transparent" />
                                    </div>
                                </div>
                                <div className="p-6">
                                    <h3 className="vertical-timeline-element-title text-xl sm:text-2xl md:text-3xl font-bold text-white">
                                        Senior Software Engineer
                                    </h3>
                                    <h4 className="vertical-timeline-element-subtitle text-base sm:text-lg font-semibold text-[#AAA6C3]">
                                        Mindteck
                                    </h4>
                                    <h4 className="vertical-timeline-element-subtitle text-base sm:text-lg font-semibold text-[#AAA6C3]">
                                        Kolkata, West Bengal, India
                                    </h4>
                                    <ul className="mt-5 list-disc ml-5 space-y-2 text-sm sm:text-base text-left">
                                        <li>Started AWS Certified Developer Activities.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: 'transparent', boxShadow: 'none', padding: 0 }}
                        contentArrowStyle={{ borderRight: '7px solid rgb(255, 255, 255)' }}
                        date="July, 2018 - June, 2021"
                        iconStyle={{ background: 'rgb(0, 0, 0)', color: '#fff' }}
                        icon={<WorkIcon />}
                    >
                        <div className="skill-card w-full h-full flex flex-col transition-all duration-500 rounded-lg group relative hover:scale-[1.05] cursor-pointer">
                            <div className="h-full w-full rounded-lg border-2 border-[#1f223c] bg-[#11152c] border-b-4 border-b-[rgba(255,255,255,0.7)] shadow-none shadow-gray-50 group-hover:border-violet-500 transition-all duration-500">
                                <div className="flex -translate-y-[1px] justify-center">
                                    <div className="w-3/4">
                                        <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-violet-500 to-transparent" />
                                    </div>
                                </div>
                                <div className="p-6">
                                    <h3 className="vertical-timeline-element-title text-xl sm:text-2xl md:text-3xl font-bold text-white">
                                        Software Engineer
                                    </h3>
                                    <h4 className="vertical-timeline-element-subtitle text-base sm:text-lg font-semibold text-[#AAA6C3]">
                                        Mindteck
                                    </h4>
                                    <h4 className="vertical-timeline-element-subtitle text-base sm:text-lg font-semibold text-[#AAA6C3]">
                                        Kolkata, West Bengal, India
                                    </h4>
                                    <ul className="mt-5 list-disc ml-5 space-y-2 text-sm sm:text-base text-left">
                                        <li>Developed several tools in C# Windows Form Application.</li>
                                        <li>Worked on WCF service based application in backend side.</li>
                                        <li>Worked on Encryption of Database and Config Data.</li>
                                        <li>Developed Database Upgradation Software to upgrade a existing production database.</li>
                                        <li>Worked on Multilingual Implementation of a Production Software.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </VerticalTimelineElement>
                </VerticalTimeline>
            </div>
            <Skills />
            <Tools />
        </div>
    )
}

export default Work;